export default __webpack_public_path__ + "static/media/Apricot.65b87f2a.jpg";